import classNames from "classnames";
import React, { PropsWithChildren } from "react";
import Button, { ButtonColor, ButtonProps, ButtonSize } from "./Buttons/Button";

type SimpleButtonProps = Omit<ButtonProps, "type" | "color" | "size" | "children"> & {
  colorTheme?: ButtonColor;
  title?: string;
  size?: ButtonProps["size"];
  horizontalAlignment?: "left" | "center" | "right";
};

const SimpleButton = ({
  colorTheme = "primary",
  horizontalAlignment = "left",
  size = ButtonSize.Normal,
  title,
  ...props
}: PropsWithChildren<SimpleButtonProps>) => {
  const getHorizontalAlignmentClassName = () => {
    switch (horizontalAlignment) {
      case "center":
        return "justify-center";
      case "right":
        return "justify-end";
      case "left":
      default:
        return "justify-start";
    }
  };

  return (
    <div className={classNames("flex mb-5", getHorizontalAlignmentClassName())}>
      <Button {...props} color={colorTheme} size={size} type="link">
        {title}
      </Button>
    </div>
  );
};

export default SimpleButton;

